import { setBlockType } from 'prosemirror-commands';
import { headingLevelAttr } from './const';
import { hasParentHeading } from './utils';
export const headingAction = (nodeType, level) => {
    const cmd = setBlockType(nodeType, { [headingLevelAttr]: level });
    return {
        isActive: hasParentHeading(level),
        isEnable: cmd,
        run: cmd,
    };
};
